import { useMemo } from 'react'
import { isPast } from 'date-fns'

import { getTimezoneDate } from '../../../constants/dates'
import { DV_360_PLATFORM } from '../../../constants/selectLists/platformList'

export const useLineItemDatesLimits = ({ campaign }) => {
  const minStartDate = useMemo(() => {
    const campaignStartDate = new Date(campaign.date_start)

    return isPast(campaignStartDate) ? getTimezoneDate(new Date(), DV_360_PLATFORM) : campaignStartDate
  }, [campaign])

  const maxEndDate = useMemo(() => {
    return getTimezoneDate(new Date(campaign.date_stop), DV_360_PLATFORM)
  }, [campaign])

  return { minStartDate, maxEndDate }
}
